interface ChatLocationCommonOpt {
  top?: boolean;
}

type SingleChatLocationOpt = {
  type: "single";
  userId: string;
  teamId: string;
  appId: string;
} & ChatLocationCommonOpt;
type GroupChatLocationOpt = {
  type: "group";
  gid: string;
} & ChatLocationCommonOpt;

type ChatLocationOpt = SingleChatLocationOpt | GroupChatLocationOpt;

// 获取聊天跳转路径
export function getChatLocationPath(opt: ChatLocationOpt) {
  const { type, top = true } = opt;
  // `/messages/s/${pin}?app=${app}&tid=${teamId}&top=true`
  // /messages/g/${item.id}?top=true
  const topStr = top ? "true" : "";
  switch (type) {
    case "single": {
      const { userId, teamId, appId } = opt as SingleChatLocationOpt;
      return `/messages/s/${userId}?app=${appId}&tid=${teamId}&top=${topStr}`;
    }
    case "group": {
      const { gid } = opt as GroupChatLocationOpt;
      return `/messages/g/${gid}?top=${topStr}`;
    }
    default:
      return "";
  }
}

export const isMeetingSessionId = (sid: string) => {
  return /^mt-/gi.test(sid);
};

export const getLiveChatMeetingCode = (sid: string) => {
  const bizId = (sid || "").split("-")[1] || "";
  return bizId.split("_")[0] || "";
};

export const getChatMeetingCode = (sid: string) => {
  return (sid || "").split("-")[1];
};

// 正则 匹配手机号
export function checkTelephone(telephone: string) {
  let reg = /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
  if (!reg.test(telephone)) {
    return false;
  } else {
    return true;
  }
}

export const isShareHintMultiMessage = (msg: any) => {
  return msg?.template?.nativeId === "share_hint_multi";
};

export const MAX_AI_UNREAD_COUNT = 12;
